import './style.scss'
import Pager from './pager'

export default Pager